// src/hooks/useCurrencyMaster.js
import { useEffect, useState } from "react";
import CommonService from "../services/common.service";

export function useCurrencyMaster() {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await CommonService.get("/master/currencies");
        
        // Extract data from response
        if (response && response.success && response.data) {
          // Handle different possible response structures
          const apiCurrencies = Array.isArray(response.data) 
            ? response.data 
            : response.data.currencies || response.data.master_currencies || [];
          
          setCurrencies(apiCurrencies);
        }
      } catch (error) {
        console.error("Error fetching currencies from API:", error);
      } finally {
        setLoading(false);
      }
    }
    
    fetchData();
  }, []);

  // Map to react-select format { value, label }
  // Handle API format variations:
  // - {currency_id: 1, currency_code: 'INR', currency_symbol: '₹', currency_name: 'Indian Rupee'}
  // - {id: 'USD', label: 'USD - US Dollar'}
  // - {currency_code: 'USD', currency_label: 'USD - US Dollar'}
  const currencyOptions = currencies.map((c) => {
    const value = c.currency_id || c.id || c.currency_code || c.code || c.value;
    
    // Get currency code and symbol
    const currencyCode = c.currency_code || c.code || value;
    const currencySymbol = c.currency_symbol || c.symbol;
    
    // Build label with symbol if available
    let label = c.currency_label || c.label;
    
    if (!label) {
      // Construct label from available fields
      const currencyName = c.currency_name || c.name;
      
      if (currencyCode && currencySymbol && currencyName) {
        label = `${currencyCode} (${currencySymbol}) - ${currencyName}`;
      } else if (currencyCode && currencySymbol) {
        label = `${currencyCode} (${currencySymbol})`;
      } else if (currencyCode && currencyName) {
        label = `${currencyCode} - ${currencyName}`;
      } else if (currencyCode) {
        label = currencyCode;
      } else {
        label = currencyName || '';
      }
    } else if (currencySymbol && !label.includes(currencySymbol)) {
      // If label exists but doesn't include symbol, add it
      const currencyCode = c.currency_code || c.code || value;
      if (currencyCode && label.startsWith(currencyCode)) {
        label = label.replace(currencyCode, `${currencyCode} (${currencySymbol})`);
      } else if (currencyCode) {
        label = `${currencyCode} (${currencySymbol}) - ${label}`;
      }
    }
    
    return { value, label, currencyCode, currencySymbol };
  }).filter(opt => opt.value !== undefined && opt.value !== null && opt.label);

  return {
    currencies,
    currencyOptions,
    loading
  };
}

